import { render } from "./Videoplay.vue?vue&type=template&id=cc0249b2"
import script from "./Videoplay.vue?vue&type=script&lang=js"
export * from "./Videoplay.vue?vue&type=script&lang=js"

import "./Videoplay.vue?vue&type=style&index=0&id=cc0249b2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__